import { render } from "./wakeups.vue?vue&type=template&id=e3a3a834&scoped=true"
import script from "./wakeups.vue?vue&type=script&lang=js"
export * from "./wakeups.vue?vue&type=script&lang=js"

import "./wakeups.vue?vue&type=style&index=0&id=e3a3a834&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3a3a834"]])

export default __exports__